  import React, { useEffect, useRef, useState } from 'react'
  import { Line } from 'react-chartjs-2'
  import {
    Chart,
    TimeScale,
    LinearScale,
    PointElement,
    LineElement,
  } from 'chart.js'
  import 'chartjs-adapter-date-fns'
  import axios from 'axios'
  import zoomPlugin from 'chartjs-plugin-zoom'

  // رجیستر کردن مقیاس و عناصر مورد نیاز
  Chart.register(TimeScale, LinearScale, PointElement, LineElement, zoomPlugin)

  const ChartPage = ({ title, chartType, startDate, endDate, reloadCharts, handleReloadCharts, handleStartDate, handleEndDate, handleTableData }) => {
    const [chartData, setChartData] = useState(null)
    const [loading, setLoading] = useState(true)
    const chartRef = useRef(null);
    const resetZoomRef = useRef(null);
    const [chartScales, setChartScales] = useState({});
    const [originalLabels, setOriginalLabels] = useState([]);
    const [oldDates, setOldDates] = useState([]);
    const [resetZoomVisible, setResetZoomVisible] = useState(false);





    // دریافت اطلاعات نمئدار ها

    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.post(
            'https://Enerbundsmu.com/api/last-send-data-device',
            {
              serial_number: 'UA016',
              name: 'TempE',
              from: startDate.getFullYear() + '-' + String(startDate.getMonth() + 1).padStart(2, '0') + '-' + String(startDate.getDate()).padStart(2, '0'), // استفاده از تاریخ شروع
              to: endDate.getFullYear() + '-' + String(endDate.getMonth() + 1).padStart(2, '0') + '-' + String(endDate.getDate()).padStart(2, '0'), // استفاده از تاریخ پایان
            }
          )

          handleTableData(response.data.data.table_date);

          if (chartType === 'batteryPower') {
            const batteryPowers = response.data.data.battery_powers
            let labels = batteryPowers.map((item) => item.date)
            const data = batteryPowers.map((item) => parseFloat(item.value))

            setOriginalLabels([...labels]);

            let newLabels = labels;

            // if (startDate.toLocaleDateString() !== endDate.toLocaleDateString()) {
            // newLabels = resetLabels(labels);
            // }

            // if (chartRef.current) {
            //   setChartScales({
            //     x: {
            //       ticks: {
            //         autoSkip: true,
            //         maxTicksLimit: 24,
            //       },
            //       min: chartRef.current.scales['x'].min,
            //       max: chartRef.current.scales['x'].max,
            //     },
            //   });
            // }

            let data_1 = batteryPowers.map((item) => {
              return {
                x: item.date.replace(' ', 'T'),
                y: parseFloat(item.value),
              };
            })

            setChartData({
              // labels: newLabels,
              datasets: [
                {
                  label: 'Battery Power',
                  data: data_1,
                  borderColor: 'rgba(0,0,0,1)',
                  backgroundColor: 'rgba(0,0,0,0.2)',
                  pointBackgroundColor: 'rgba(0,0,0,1)',
                  pointBorderColor: '#fff',
                },
              ],
            });
          } else if (chartType === 'loadVoltages') {
            const loadVoltagesOne = response.data.data.load_voltages_one
            const loadVoltagesTwo = response.data.data.load_voltages_two

            const labelsVO1 = loadVoltagesOne.map((item) => item.date)
            const vo1Data = loadVoltagesOne.map((item) => parseFloat(item.value))

            const labelsVO2 = loadVoltagesTwo.map((item) => item.date)
            const vo2Data = loadVoltagesTwo.map((item) => parseFloat(item.value))

            setOriginalLabels([...labelsVO1, ...labelsVO2]);

            let newLabelsVO1 = labelsVO1,
              newLabelsVO2 = labelsVO2;

            // if (startDate.toLocaleDateString() !== endDate.toLocaleDateString()) {
            // newLabelsVO1 = resetLabels(labelsVO1);
            // newLabelsVO2 = resetLabels(labelsVO2);
            // }
            // console.log(newLabelsVO1);
            // console.log(vo1Data);
            // console.log(vo2Data);
            // console.log(chartRef.current.scales['x'].min);
            // if (chartRef.current) {
            // let ticks = {};

            // if (startDate.toLocaleDateString() === endDate.toLocaleDateString()) {
            //   ticks = {
            //     autoSkip: true,
            //     maxTicksLimit: 24,
            //   };
            // }

            // setChartScales({
            //   x: {
            //     // ticks: ticks,
            //     min: chartRef.current.scales['x'].min,
            //     max: chartRef.current.scales['x'].max,
            //   },
            // });
            // }

            let data_1 = loadVoltagesOne.map((item) => {
              return {
                x: item.date,
                y: parseFloat(item.value),
              };
            })

            let data_2 = loadVoltagesTwo.map((item) => {
              return {
                x: item.date,
                y: parseFloat(item.value),
              }
            })

            setChartData({
              // labels: newLabelsVO1,
              datasets: [
                {
                  label: 'VO1',
                  // data: vo1Data,
                  data: data_1,
                  borderColor: 'rgba(54,162,235,1)',
                  backgroundColor: 'rgba(54,162,235,0.2)',
                  pointBackgroundColor: 'rgba(54,162,235,1)',
                  pointBorderColor: '#fff',
                },
                {
                  label: 'VO2',
                  // data: vo2Data,
                  data: data_2,
                  borderColor: 'rgba(255,99,132,1)',
                  backgroundColor: 'rgba(255,99,132,0.2)',
                  pointBackgroundColor: 'rgba(255,99,132,1)',
                  pointBorderColor: '#fff',
                },
              ],
            })
          } else if (chartType === 'batteryVoltage') {
            const batteryVoltages = response.data.data.battery_voltages
            let labels = batteryVoltages.map((item) => item.date)
            const data = batteryVoltages.map((item) => parseFloat(item.value))

            setOriginalLabels([...labels]);

            let newLabels = labels;

            // if (startDate.toLocaleDateString() !== endDate.toLocaleDateString()) {
            newLabels = resetLabels(labels);
            // }

            // if (chartRef.current) {
            //   setChartScales({
            //     x: {
            //       ticks: {
            //         autoSkip: true,
            //         maxTicksLimit: 24,
            //       },
            //       min: chartRef.current.scales['x'].min,
            //       max: chartRef.current.scales['x'].max,
            //     },
            //   });
            // }

            setChartData({
              labels: newLabels,
              datasets: [
                {
                  label: 'Battery Voltage',
                  data,
                  borderColor: 'rgba(0,123,255,1)',
                  backgroundColor: 'rgba(0,123,255,0.2)',
                  pointBackgroundColor: 'rgba(0,123,255,1)',
                  pointBorderColor: '#fff',
                },
              ],
            })
          } else if (chartType === 'statusChart') {
            const statusGens = response.data.data.statusGens
            const statusSsrs = response.data.data.statusSsrs

            let labels = [
              ...new Set([
                ...statusGens.map((item) => item.date),
                ...statusSsrs.map((item) => item.date),
              ]),
            ].sort()

            setOriginalLabels([...labels]);

            let newLabels = labels;

            // if (startDate.toLocaleDateString() !== endDate.toLocaleDateString()) {
            newLabels = resetLabels(labels);
            // }

            // if (chartRef.current) {
            //   setChartScales({
            //     x: {
            //       ticks: {
            //         autoSkip: true,
            //         maxTicksLimit: 24,
            //       },
            //       min: chartRef.current.scales['x'].min,
            //       max: chartRef.current.scales['x'].max,
            //     },
            //   });
            // }

            const gensData = statusGens.map((item) => parseFloat(item.value))
            const ssrsData = statusSsrs.map((item) => parseFloat(item.value))

            setChartData({
              labels: newLabels,
              datasets: [
                {
                  label: 'GENS',
                  data: gensData,
                  borderColor: 'rgba(75,192,192,1)',
                  backgroundColor: 'rgba(75,192,192,0.2)',
                  pointBackgroundColor: 'rgba(75,192,192,1)',
                  pointBorderColor: '#fff',
                },
                {
                  label: 'SSRS',
                  data: ssrsData,
                  borderColor: 'rgba(255,159,64,1)',
                  backgroundColor: 'rgba(255,159,64,0.2)',
                  pointBackgroundColor: 'rgba(255,159,64,1)',
                  pointBorderColor: '#fff',
                },
              ],
            })
          }

          setLoading(false)
        } catch (error) {
          console.error('Error fetching data:', error)
          setLoading(false)
        }

        handleReloadCharts(false)
      }

      if (reloadCharts) {
        fetchData()
      }

      const interval = setInterval(fetchData, 60000) // هر 60 ثانیه یکبار

      return () => clearInterval(interval) // پاک‌سازی بازه زمانی هنگام خروج از کامپوننت
    }, [chartType, reloadCharts])

    const handleResetZoom = () => {
    if (chartRef.current) {
      const chart = chartRef.current;
      chart.options.scales.x.time.unit = 'day'; // مقدار پیش‌فرض
      chart.options.scales.x.time.stepSize = 1; // مقدار پیش‌فرض

      chart.resetZoom();

      // مخفی کردن دکمه بعد از ریست زوم
      setResetZoomVisible(false);

      // به‌روزرسانی نمودار
      chart.update();


    }
  };

    const resetLabels = (labels) => {
      let lastDate = null;

      labels.forEach((label, index) => {
        let [date, time] = label.split(' ');

        if (date !== lastDate) {
          lastDate = date;
          labels[index] = new Date(label).toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'short',
          });
        } else {
          labels[index] = time.substring(0, 5);
        }
      });

      return labels;
    };

    





    // تنظیمات کلی نمودار
    const chartOptions = {
      responsive: true,
      plugins: {
        legend: { position: 'top' },
        tooltip: {
          callbacks: {
            title: function (tooltipItems) {
              return new Date(tooltipItems[0].raw.x).toLocaleString();
            }
          }
        },
        zoom: {
          pan: {
            enabled: true,
            mode: 'x',
            modifierKey: 'ctrl',
          },
          zoom: {
            drag: {
              enabled: true
            },
            mode: 'x',
            onZoomStart: ({ chart }) => {
              const xScale = chart.scales.x;
              const start = xScale.min;
              const end = xScale.max;

              const diff = end - start;
            const oneMinute = 60 * 1000 * 10; // یک دقیقه به میلی‌ثانیه
            if (diff <= oneMinute) {
              console.log("Zoom canceled: Time range is less than one minute.");
              return false; // زوم را متوقف می‌کند
            }
            },
            onZoomComplete: ({ chart }) => {
              const xScale = chart.scales.x;
              const start = xScale.min;
              const end = xScale.max;
             


              // در هنگام زوم، مقیاس زمانی تغییر می‌کند (به ساعت‌ها یا روزها)
              const diff = end - start;
              const unit = diff < 24 * 60 * 60 * 1000 ? 'minute' : (diff < 7 * 24 * 60 * 60 * 1000 ? 'hour' : 'day');

              chart.options.scales.x.time.unit = unit;
              setResetZoomVisible(true);
              //handleZoomSync( start, end);
              chart.update();
            },
          },
        },
      },
    
      scales: {
        x: {
          type: 'time',
          time: {
            unit: 'day',  // نمایش واحد زمان روزها به طور پیش فرض
            stepSize: 1,  // فاصله یک روز برای هر تیک
            displayFormats: {
              day: 'MMM dd',  // نمایش تاریخ به صورت روز ماه
              hour: 'HH:mm',  // نمایش ساعت و دقیقه
            },
            tooltipFormat: 'MMM dd, HH:mm'
          },
          ticks: {
            maxTicksLimit: 10,  // محدود کردن تعداد تیک‌ها
            autoSkip: false,    // غیرفعال کردن autoSkip برای جلوگیری از تداخل تیک‌ها
            autoSkipPadding: 10,  // فاصله‌دهی مناسب به تیک‌ها
            maxRotation: 45,   // چرخش تیک‌ها به 45 درجه
            minRotation: 45,   // حداقل چرخش برای تیک‌ها
            callback: function (value, index, ticks) {
              const diff = ticks[ticks.length - 1].value - ticks[0].value;
              const currentDate = new Date(ticks[index].value);
              const previousDate = index > 0 ? new Date(ticks[index - 1].value) : null;
    
              // اگر اختلاف زمانی کمتر از یک روز باشد، فقط زمان نمایش داده می‌شود
              if (!previousDate || currentDate.getDate() !== previousDate.getDate()) {
                return currentDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
              } else {
                return currentDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
              }
            }
          }
        },
        y: chartType === 'batteryPower'
        ? {
            beginAtZero: false,
            min: -10000,
            max: 10000,
          }
        : chartType === 'loadVoltages'
        ? {
            beginAtZero: true,
            min: 0,
            max: 600,
          }
        : {
            beginAtZero: true,
          },


          
          
      },
    };
    


    if (loading) return <p>Loading...</p>

    return (
      <div>
        <div>
          <h2 className='chart-title'>{title}</h2>
          {resetZoomVisible && (
            <button ref={resetZoomRef} onClick={handleResetZoom} className='reset-zoom-button' style={{ float: 'right' }}>
              Reset Zoom
            </button>
          )}
        </div>
        <Line ref={chartRef} data={chartData} options={chartOptions} />
      </div>
    );
  }

  export default ChartPage


  /** */